const SET_LOAN_IS_VISIBLE = 'SET_LOAN_IS_VISIBLE';

export { SET_LOAN_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/Loan/constants.js